import { render } from "./UtilsCrearPlantilla.vue?vue&type=template&id=1cf0ba5a"
import script from "./UtilsCrearPlantilla.vue?vue&type=script&lang=js"
export * from "./UtilsCrearPlantilla.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__